const productForm = document.getElementById('product-form');

if (productForm) {
    const addToCartBtn = productForm.querySelector('button[type="submit"]');
    const addToCartLabel = addToCartBtn?.querySelector('#add-to-cart');
    const plusBtn = productForm.querySelector('#product-form-plus');
    const minusBtn = productForm.querySelector('#product-form-minus');
    const quantityInput = productForm.querySelector('#product-form-quantity');
    const maxOfStockMessage = productForm.querySelector('.warning-stock');

    const getQuantityDrawer = () => {
        const drawerItem = document.querySelector(
            `.cart-drawer__item[data-product-id="${productForm.dataset.productid}"] input[type="text"]`
        );
        return drawerItem ? parseInt(drawerItem.value, 10) || 0 : 0;
    };

    const updateButtonsState = () => {
        const textAddToCart = window.variantStrings.addToCart;
        const inputQuantityDrawer = getQuantityDrawer();
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        const minValue = parseInt(quantityInput.min, 10) || 0;
        const maxValue = parseInt(quantityInput.max, 10) || 0;
        const maxTotal = maxValue === -1 ? Infinity : maxValue - inputQuantityDrawer;

        minusBtn.disabled = currentValue <= minValue;
        plusBtn.disabled = maxTotal <= 0 || currentValue >= maxTotal;
        maxOfStockMessage.classList.toggle('hidden', maxTotal > 0 && currentValue < maxTotal);

        const nextLabel = maxValue === inputQuantityDrawer ? window.variantStrings.soldOut : textAddToCart;
        if (addToCartLabel) {
            addToCartLabel.textContent = nextLabel;
        } else if (addToCartBtn) {
            addToCartBtn.textContent = nextLabel;
        }
    };

    const changeQuantity = (delta) => {
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        const minValue = parseInt(quantityInput.min, 10) || 0;
        const maxTotal =
            parseInt(quantityInput.max, 10) === -1
                ? Infinity
                : parseInt(quantityInput.max, 10) - getQuantityDrawer();

        const newValue = Math.min(Math.max(currentValue + delta, minValue), maxTotal);
        if (newValue !== currentValue) {
            quantityInput.value = newValue;
            updateButtonsState();
        }
    };

    if (quantityInput && plusBtn && minusBtn) {
        quantityInput.addEventListener('input', updateButtonsState);
        plusBtn.addEventListener('click', () => changeQuantity(1));
        minusBtn.addEventListener('click', () => changeQuantity(-1));
        updateButtonsState();
    } else if (quantityInput === null) {
        console.error("Input não encontrado. Verifique o ID do elemento.");
    }
}

// FUNÇÃO PARA BOTÃO FLUTUANTE NA PDP
(function() {
const floatingBar = document.getElementById('floating-buy-bar');
if (!floatingBar) return;

const buySection = document.querySelector('#product-form');
if (!buySection) return;

function toggleFloatingBar() {
    const rect = buySection.getBoundingClientRect();
    const isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;

    if (isOutOfView) {
    floatingBar.classList.remove('translate-y-[calc(100%+1rem)]');
    } else {
    floatingBar.classList.add('translate-y-[calc(100%+1rem)]');
    }
}

window.addEventListener('scroll', toggleFloatingBar, { passive: true });
toggleFloatingBar();
})();